/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI75598ReqOrderObjectsItem {
  
  /**  */
  orderByColumn?: string;
  
  /**  */
  orderByDesc?: boolean;
  
};
    
  
    
export interface IAPI75598ResListItemTaskExcelImportV2FormObj {
  
  /** 表头 ,String */
  heads: string[];
  
  /** 表数据 ,Map */
  values: any[];
  
  /** 模型名称 */
  modelName?: string;
  
};
    
  
    
export interface IAPI75598ResListItem {
  
  /** 主键 */
  id?: number;
  
  /** 用户编号 */
  userId?: string;
  
  /** 名称 */
  modelName?: string;
  
  /** 内容 */
  content?: string;
  
  /** 数据唯一id */
  dataId?: string;
  
  /** 0否1是 */
  isDeleted?: number;
  
  /** 创建人 */
  creator?: string;
  
  /** 修改人 */
  updater?: string;
  
  /**  */
  createdAt?: string;
  
  /**  */
  updatedAt?: string;
  
  /** 模型详情转换 ,TaskExcelImportV2Form */
  taskExcelImportV2Form?: IAPI75598ResListItemTaskExcelImportV2FormObj;
  
};
    
  



export interface API75598Req {
  
  /** 模型名称 */
  modelName?: string;
  /**  */
  pageSize?: number;
  /**  */
  pageIndex?: number;
  /**  */
  rowId?: string;
  /**  */
  jumpType?: number;
  /**  */
  searchCount?: boolean;
  /** OrderByColumn */
  orderObjects?: IAPI75598ReqOrderObjectsItem[];
};



export interface API75598Res {
  /** T  */
  list?: IAPI75598ResListItem[];
  /**   */
  totalNumber?: number;
  /**   */
  totalPage?: number;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: number;
  /**   */
  pageIndex?: number;
  
};


// 接口函数 75598 /chat/task/model/page/list

export interface IUsePostAPI75598Return {
  /** /chat/task/model/page/list: 接口请求状态 */
  isAPI75598Loading: boolean;
  /** /chat/task/model/page/list: 接口请求返回数据 */
  dataAPI75598: API75598Res;
  /**  /chat/task/model/page/list: 接口数据请求方法 */
  fetchAPI75598Data: (inputs: API75598Req, config?: YWRequestConfig) => Promise<API75598Res>;
  /** /chat/task/model/page/list: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI75598 = ():IUsePostAPI75598Return => {
  let isMount = true;
  const [isAPI75598Loading, setIsAPI75598Loading] = useState(false);
  const [dataAPI75598, setDataAPI75598] = useState<API75598Res>({} as API75598Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/task/model/page/list`;

  const fetchAPI75598Data = async (inputs: API75598Req, config?: YWRequestConfig): Promise<API75598Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75598Req>) || {}) as API75598Req;
    
  
    if ( isMount ) {
      setIsAPI75598Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API75598Res>(`${basePath}/yoaichat-web/chat/task/model/page/list`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI75598(res || {} as API75598Res);
        setIsAPI75598Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75598Loading(false);
      }
      return false as unknown as API75598Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75598Loading,
    dataAPI75598,
    fetchAPI75598Data,
    requestUrl,
  }
}

